"use client";

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SUPPORT_RECIPIENTS, EmailRecipient } from "@/lib/email-recipients";
import { Mail } from "lucide-react";

interface RecipientSelectorProps {
  value: string | undefined;
  onValueChange: (recipientId: string) => void;
  customRecipient?: EmailRecipient;
}

export function RecipientSelector({ value, onValueChange, customRecipient }: RecipientSelectorProps) {
  // Include custom recipient in the list if provided
  const allRecipients = customRecipient
    ? [customRecipient, ...SUPPORT_RECIPIENTS.filter((r) => r.id !== customRecipient.id)]
    : SUPPORT_RECIPIENTS;

  const selected = allRecipients.find((r) => r.id === value);

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium">To</label>
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger>
          <SelectValue placeholder="Select recipient...">
            {selected && (
              <span className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                {selected.name}
              </span>
            )}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {allRecipients.map((recipient) => (
            <SelectItem key={recipient.id} value={recipient.id}>
              <div className="flex flex-col">
                <span className="font-medium">{recipient.name}</span>
                <span className="text-xs text-muted-foreground">
                  {recipient.description}
                </span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
